// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged
} from 'firebase/auth';
import {
  getFirestore,
  collection,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  onSnapshot,
  serverTimestamp,
  arrayUnion,
  arrayRemove
} from 'firebase/firestore';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCoZam77EfvxWiyu1R2IEaQjQ4Tl19VAlc",
  authDomain: "notepad-56a6a.firebaseapp.com",
  projectId: "notepad-56a6a",
  storageBucket: "notepad-56a6a.firebasestorage.app",
  messagingSenderId: "667137513139",
  appId: "1:667137513139:web:f1a212540ffda072a002c6",
  measurementId: "G-MJT74T6RBH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

// Collections
const listsCollection = collection(db, 'lists');
const userSettingsCollection = collection(db, 'userSettings');
const wellnessLogsCollection = collection(db, 'wellnessLogs');

// Auth functions
export const registerUser = async (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
};

export const signInUser = async (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const signOutUser = async () => {
  return signOut(auth);
};

export const getCurrentUser = () => {
  return auth.currentUser;
};

export const onAuthStateChange = (callback) => {
  return onAuthStateChanged(auth, callback);
};

// List functions
export const getUserLists = (userId, callback) => {
  const q = query(
    listsCollection,
    where('userId', '==', userId)
  );

  return onSnapshot(q, (snapshot) => {
    const lists = [];
    snapshot.forEach((doc) => {
      lists.push({ id: doc.id, ...doc.data() });
    });
    // Sort by order on the client side to avoid needing a composite index
    lists.sort((a, b) => (a.order || 0) - (b.order || 0));
    callback(lists);
  }, (error) => {
    console.error('Error fetching lists:', error);
    callback([]);
  });
};

export const addList = async (userId, name, type) => {
  try {
    const newList = {
      userId,
      name,
      type,
      items: [],
      order: Date.now(),
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };

    const docRef = doc(listsCollection);
    await setDoc(docRef, newList);
    console.log('List created successfully:', docRef.id);
    return docRef.id;
  } catch (error) {
    console.error('Error creating list:', error);
    throw error;
  }
};

export const updateList = async (listId, updates) => {
  const listRef = doc(listsCollection, listId);
  await updateDoc(listRef, {
    ...updates,
    updatedAt: serverTimestamp()
  });
};

export const deleteList = async (listId) => {
  const listRef = doc(listsCollection, listId);
  await deleteDoc(listRef);
};

// List item functions
export const addListItem = async (listId, item) => {
  const listRef = doc(listsCollection, listId);
  await updateDoc(listRef, {
    items: arrayUnion({
      id: Date.now().toString(),
      ...item,
      createdAt: new Date().toISOString()
    }),
    updatedAt: serverTimestamp()
  });
};

export const updateListItem = async (listId, items) => {
  const listRef = doc(listsCollection, listId);
  await updateDoc(listRef, {
    items,
    updatedAt: serverTimestamp()
  });
};

export const deleteListItem = async (listId, itemId, items) => {
  const updatedItems = items.filter(item => item.id !== itemId);
  const listRef = doc(listsCollection, listId);
  await updateDoc(listRef, {
    items: updatedItems,
    updatedAt: serverTimestamp()
  });
};

// Wellness log functions
export const saveWellnessLog = async (userId, date, logData) => {
  try {
    const logId = `${userId}_${date}`;
    const logRef = doc(wellnessLogsCollection, logId);
    await setDoc(logRef, {
      userId,
      date,
      ...logData,
      updatedAt: serverTimestamp()
    }, { merge: true });
  } catch (error) {
    console.error('Error saving wellness log:', error);
    throw error;
  }
};

export const getWellnessLogs = (userId, callback) => {
  const q = query(
    wellnessLogsCollection,
    where('userId', '==', userId),
    orderBy('date', 'desc')
  );

  return onSnapshot(q, (snapshot) => {
    const logs = [];
    snapshot.forEach((doc) => {
      logs.push(doc.data());
    });
    callback(logs);
  }, (error) => {
    console.error('Error fetching wellness logs:', error);
    callback([]);
  });
};

export { auth, db, listsCollection, userSettingsCollection, wellnessLogsCollection };
